import request from '@/utils/request'

let Activity_glApi = {

  /*活动管理列表*/
  list(data) {
    return request._post('/shop/plus.activity_gl.Index/index', data);
},
/*添加活动管理*/
add(data) {
    return request._post('/shop/plus.activity_gl.Index/add', data);
},
/*修改活动管理*/
edit(data) {
    return request._post('/shop/plus.activity_gl.Index/edit', data);
},
/*删除活动管理*/
del(data) {
    return request._post('/shop/plus.activity_gl.Index/del', data);
},
/*活动管理详情*/
detail(data) {
  return request._post('/shop/plus.activity_gl.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.activity_gl.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.activity_gl.Setting/getSetting', data, errorback);
    },
}
export default Activity_glApi;



// WEBPACK FOOTER //
// ./src/api/activity_gl.js